import type { FC } from 'react';
import { memo } from 'react';

import type { SettingsRecipeT } from './component';
import {
  RateRecipeBtn,
  RecipeAuthor,
  RecipeDescription,
  RecipeImage,
  RecipeInfo,
  RecipeIsPromo,
  RecipePFC,
  RecipeStats,
  RecipeTip
} from './components/components';
import RecipeIngredients from './components/RecipeIngredients';
import RecipeSteps from './components/RecipeSteps';

const RecipeDesktop: FC<SettingsRecipeT> = ({
  toggleLeaveRecipeFeedbackModal,
  scrollToCommentsBlock,
  recipe,
  handleRecipeFavorites,
  isFavorite,
  isDesktop,
  isWithoutPhotos
}) => {
  if (!recipe) {
    return null;
  }
  return (
    <div className='grid grid-cols-2 gap-x-5 mb-14'>
      <div className='relative'>
        <RecipeImage
          video_code={recipe.video_code}
          title={recipe.title}
          isFavorite={isFavorite}
          rubric={recipe.bludoItem?.title}
          handleRecipeFavorites={handleRecipeFavorites}
          mainImage={recipe?.attachmentsItem?.cacheItem?.[0]?.filePath}
        />
        {!!recipe.recipeInstructions?.length && (
          <RecipeSteps
            video_code={recipe.video_code}
            isWithoutPhotos={isWithoutPhotos}
            steps={recipe.recipeInstructions}
          />
        )}
      </div>
      <div className=''>
        <div className='flex items-center justify-between w-full mb-4'>
          <RecipeInfo
            date={recipe.date}
            rating={recipe.rating}
            scrollToCommentsBlock={scrollToCommentsBlock}
            comments={recipe.comments_number}
            viewCount={recipe.viewCount}
            // isFavorite={isFavorite}
            // handleRecipeFavorites={handleRecipeFavorites}
          />
          <div className='flex items-center gap-x-3'>
            <RateRecipeBtn
              _votedRating={recipe._votedRating}
              toggleLeaveRecipeFeedbackModal={toggleLeaveRecipeFeedbackModal}
            />
          </div>
        </div>
        <div className='mb-3'>
          {!!recipe.is_product_promo && <RecipeIsPromo />}
        </div>
        <h1 data-testid='recipe-title' className='mb-3 text-3xl font-medium'>
          {recipe.title}
        </h1>
        <RecipeDescription text={recipe.text} />
        <RecipeStats
          difficulty={recipe.recipes_difficult}
          serving={recipe.serving}
          time={recipe.cooking_time}
          calories={recipe.calories}
        />
        <RecipePFC
          protein={recipe.protein}
          fat={recipe.fat}
          carbohydrates={recipe.carbohydrates}
          calories={recipe.calories}
        />
        <RecipeAuthor
          fio={recipe.authorItem?.fio}
          identify={recipe.authorItem?.identify}
          title={recipe.authorItem?.title}
          avatar={
            recipe.authorItem?.userItem?.attachmentsItem?.tempFullFilePath
          }
        />
        {recipe.tip && <RecipeTip tip={recipe.tip} isGrey={isWithoutPhotos} />}
        <RecipeIngredients
          ingredients={recipe.recipeIngredients}
          isDesktop={isDesktop}
        />
      </div>
    </div>
  );
};

export default memo(RecipeDesktop);
